import {formRules} from "../../config/validations/formRules";
import {validations} from "../../config/validations/validations";

export const rules: any = {
    name: () => formRules.name(),
    email: (field?: string) => [validations.required.text(field), validations.email(field)],
};
